// extracted by mini-css-extract-plugin
export default {"name":"Logo_name__5xReZ"};